import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";

if (dbh_helper.getUrlArea() == "leistungsnachweise") {
    $(document).ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if (id != "") {

        }

        $("#typescriptLeistungsnachweisProxy").on("click", function (event, actionName, controllerName, parameter, htmlId, doOnSuccess, type) {

            if (type === "post") {
                sendPostRequest(actionName, controllerName, parameter, htmlId, doOnSuccess);
            } else {
                dbh_helper.SendGetRequest(actionName, controllerName, parameter, htmlId, doOnSuccess);
            }
        })

        $(".showZeitraeumeBtn").on("click", function (event) {
            const $this = $(this);
            const id = $this.data("id");
            const interval = $this.data("interval");

            dbh_helper.SendGetRequest("GetZeitraumPopupView", "Leistungsnachweise", [["id", id], ["interval", interval]], "#lnZeitraeume-placeholder", () => {
                $('#LNZeitraumViewComponentPopup').show();
            });
        });
        $(document).on('click', '#closeTimelineBtn', function () {
            $('#LNZeitraumViewComponentPopup').hide();
        });

        $(document).on('click', '.btn.lnSubmit', function () {
            const $this = $(this);
            const id = $this.data('id');
            const text = $this.data('text');

            const $confirmInfoText = $('#confirmInfoText');
            $confirmInfoText.html(text);
            $('#submitConfirmSubmitBtn').off('click');
            $('#submitConfirmSubmitBtn').on('click', function () {
                $(`#${id}`).trigger('click');
            });

            $('#lnSumbitConfirmPopup').css("display", 'block');
        });

        $('#submitConfirmCancelBtn').on('click', function () {
            $('#lnSumbitConfirmPopup').css("display", 'none');
        });

        $(document).on('click', '.tdLnPos', function () {
            const rowid = $(this).data('rowid');
            dbh_helper.SendGetRequest("GetPositionPopupView", "Leistungsnachweise", [["positionId", rowid]], "#lnPosition-placeholder", () => { $('#LNPositionenViewComponentPopup').show(); });
        });

        $(document).on('click', '.lnPosResult .tableDeleteButton', function (e) {
            const rowid = $(this).data('rowid');
            dbh_helper.SendGetRequest("DeleteLnPositionZuweisung", "Leistungsnachweise", [["positionId", rowid]], "#lnPosition-placeholder", () => { $('#LNDeleteViewComponentPopup').show(); });
            e.preventDefault();
            e.stopPropagation();
        });

        $(document).on('click', '#savePositionChangeBtn', function (e) {
            let dbhCustomValidation = new dbh_custom_validation();
            if (!dbhCustomValidation.validateForm("#lnPositionPopup")) {
                return;
            }

            const form = dbh_helper.findNearestForm(e.currentTarget);
            const parameter = dbh_helper.getParameterArrayForForm(form);
            dbh_helper.FormatDatesParameterArray(parameter);

            dbh_helper.SendGetRequest('SavePositionChange', 'Leistungsnachweise', parameter, null, () => {
                sendReloadForLNPos(id, '#LNPositionenViewComponentPopup');

                dbh_helper.SendGetRequest('ReloadLNStunden', 'Leistungsnachweise', [["id", $('#PK_Leistungsnachweise').val()]], '#LeistungsnachweiseStundenUebersicht',
                    () => {
                    });
            });
        });

        $(document).on('click', '#editLnPositionCancelBtn', function () {
            $('#LNPositionenViewComponentPopup').hide();
        });

        $(document).on('click', '#deleteLnPositionConfirmBtn', function () {
            const posId = $(this).data('id');
            dbh_helper.SendGetRequest("DeleteLnPositionAfterConsent", "Leistungsnachweise", [["key", posId]], null, () => {
                sendReloadForLNPos(id, '#LNDeleteViewComponentPopup');

                dbh_helper.SendGetRequest('ReloadLNStunden', 'Leistungsnachweise', [["id", $('#PK_Leistungsnachweise').val()]], '#LeistungsnachweiseStundenUebersicht',
                    () => {
                    });
            });
        });

        $(document).on('click', '#cancelDeletePositionBtn', function () {
            $('#LNDeleteViewComponentPopup').hide();
        });

        $(document).on('click', '#addLeistungspositionBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);

            let dbhCustomValidation = new dbh_custom_validation();
            if (!dbhCustomValidation.validateForm(form)) {
                return;
            }

            const parameter = dbh_helper.getParameterStringForForm(form);
            dbh_helper.FormatDatesParameterArray(parameter);

            sendPostRequest('AddPosition', 'Leistungsnachweise', parameter, null, () => {
                $('.addSvrError').html("");
                sendReloadForLNPos(id);
                // alle Felder zurücksetzen bis auf Auswahl der BetreuerIn
                //$('.form-text:not(select)').val("");
                //$('.form-text').prop('checked', false);
                ($('#FromLeistungsnachweiseAddPosition')[0] as HTMLFormElement).reset();
            }, (ajaxResult) => {
                $('.addSvrError').html(ajaxResult);
            });
        });

        dbh_helper.setDefaultFormValues();

    });
}

const sendPostRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null, doOnError = null) => {

    return new dbh_ajax().sendPostRequest({
        actionName: actionName,
        controllerName: controllerName,
        parameter: parameter,
        loadingTarget: null,
        callbackSuccess: (ajaxResult: any) => {
            if (htmlId !== undefined && htmlId !== null) {
                $(`${htmlId}`).html(ajaxResult);
            }
            if (doOnSuccess !== undefined && doOnSuccess !== null) {
                doOnSuccess();
            }
        },
        callbackError: (ajaxResult: XMLHttpRequest) => {
            if (doOnError !== undefined && doOnError !== null) {
                doOnError(ajaxResult.responseText);
            }
        }
    });
}

const sendReloadForLNPos = (id, hideId = undefined) => {
    const jsonPosTableInfo = $('#jsonPosTableInfo').val();
    const jsonGlobalInfo = $('#jsonGlobalInfo').val();

    const model = [
        ['id', id],
        ['jsonPosTableInfo', jsonPosTableInfo],
        ['jsonGlobalInfo', jsonGlobalInfo]
    ];

    dbh_helper.SendGetRequest('ReloadLNTable', 'Leistungsnachweise', model, '#LeistungsnachweisePositionenTabelleMitSuche',
        () => {
            if (hideId) {
                $(hideId).hide();
            }
        });

    if ($("#LeistungsnachweiseStundenUebersicht").length > 0)
    {
        dbh_helper.SendGetRequest('ReloadLNStunden', 'Leistungsnachweise', model, '#LeistungsnachweiseStundenUebersicht',
            () => {
                if (hideId) {
                    $(hideId).hide();
                }
            });
    }
}
